import { ControllerFieldState } from 'react-hook-form'

export const getFormValidationMessage = (fieldState: ControllerFieldState) => {
  switch (fieldState.error?.type) {
    case 'required':
      return 'This field is required.'
    case 'min':
      return 'This field contains too low value.'
    case 'max':
      return `The field contains too high value.`
    case 'pattern':
      return `This field must match the following pattern.`
    case 'validate':
      return fieldState.error.message
    default:
      return ''
  }
}
